//定义公共属性和方法
let common = {
  idd: 1234567,

//设置网页title
  changetitle (title) {
    document.title = title
  },
  nickname: '',
  logo: '',
  openid: '',
  projectname: 'mbsptMobiletest/',
  userinfo: '',

//   //微信登陆
  wxlogin (that, userInfo, querydata) {
    let urls = ''
    let urls2 = ''
    if (!(userInfo)) {
      let spearopenid = ''
      if (querydata.openid) {
        spearopenid = querydata.openid
      }
      that.$axios.post('/merchant/api/activity/merchant-union-market-extend/get/wxcode', that.$qs.stringify({
        'activityId': querydata.activityId,
        'storeId': querydata.storeId,
        'merId': querydata.merId,
        'price': querydata.price,
        'spreadOpenid': spearopenid
      }))
        .then(response => (
          console.log('授权后的信息' + response.data.data.url),
            urls2 = response.data.data.url + '?activityId=' + querydata.activityId + '&merId=' + querydata.merId + '&storeId=' + querydata.storeId + '&price=' + querydata.price + '&spreadOpenid=' + spearopenid,
            window.location.href = urls2,
            console.log(urls2)

        ))
        .catch((function (error) {
          console.log(error)
        }))
    } else {

      let data = JSON.parse(userInfo)
      that.userinfo = data
      // console.log(data)
      that.nickname = data.nickname
      that.logo = data.headimgurl
      that.openid = data.openid
    }
  },
  activitydata: '',
  unionInfo: '', /*商家活动*/
  URL: 'http://files.mbscloud.cn/upload', //图片的域名
  //wxappUrl: 'http://17j6d21567.imwork.net/',//后端的域名
  //weixinUrl: 'https://17j6d21567.imwork.net/',//前端的域名
  //wxappUrl :"http://api-test.mbspt.com/",//后端的域名
  //weixinUrl : "http://testh5.mbspt.com/",//前端的域名
  wxappUrl: 'http://wx.api.mbscloud.cn/',//后端的域名
  weixinUrl: 'http://h5.store.mbscloud.cn/',//前端的域名

}

export default common



// WEBPACK FOOTER //
// ./src/Common/common.js